export function rangeToStartEnd(
  range: string
): { start: string; end: string } | null {
  const [base, start, end, ...rest] = range.split(",");
  if (base && start && end && rest.length === 0) {
    return {
      start: base + start,
      end: base + end,
    };
  }
  return null;
}
